module.exports = __webpack_public_path__ + "static/img/omron-healthcare.8c27a1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/omron-healthcare.jpg
// module id = xdYV
// module chunks = 0